var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlateNoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83331 4.14286H11M2.83331 6H11M11.6667 9H2.33333C1.59733 9 1 8.488 1 7.85714V2.14286C1 1.512 1.59733 1 2.33333 1H11.6667C12.4027 1 13 1.512 13 2.14286V7.85714C13 8.488 12.4027 9 11.6667 9Z",
    stroke: "#959EB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlateNoIcon);
export default __webpack_public_path__ + "static/media/PlateNoIcon.6e3f8d980120da8d13b3caa8227a96a9.svg";
export { ForwardRef as ReactComponent };